import InfoIcon from '@mui/icons-material/InfoOutlined';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { IconButton, InputAdornment, List, ListItem, ListSubheader, Menu, MenuItem, TextField, Tooltip, Typography } from "@mui/material"
import { groupBy } from "lodash"
import { Fragment, useState } from 'react';

import { FormOption } from "~/utils/forms";

type Props = {
  providers: (FormOption & { invalidReason: string | undefined })[];
}

const UnavailableProviders = ({ providers }: Props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLSpanElement>(null);

  const invalid = providers.filter(p => p.invalidReason);
  const providersByInvalid = groupBy(invalid, "invalidReason");

  const [filter, setFilter] = useState("");

  if (!invalid.length) { return null; }

  const shouldShow = (reason: string) => {
    return reason.toLowerCase().match(filter)
    || providersByInvalid[reason].some(p => p.label.toLowerCase().match(filter))
  };

  return <>
    <Tooltip title="Click for more info"><MenuItem onClick={(e) => setAnchorEl(e.currentTarget)}>
      <Typography color="textDisabled">
        {invalid.length} unavailable provider{invalid.length === 1 ? '' : 's'}
      </Typography>
      <InfoIcon fontSize={"small"} color="primary" sx={{ ml: 1, verticalAlign: "text-bottom", right: 16, position: "absolute" }} />
    </MenuItem></Tooltip>
    <Menu
      open={!!anchorEl}
      anchorEl={anchorEl}
      onClose={() => setAnchorEl(null)}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'center',
        horizontal: 'left',
      }}
    >
      <List sx={{ p: 0 }} dense>
        <ListItem>
          <TextField
            size="small"
            value={filter}
            onChange={(e) => setFilter(e.target.value.toLowerCase())}
            slotProps={{ input: {
              endAdornment: (
                <InputAdornment position="end">
                {filter ? <IconButton sx={{ p: 0 }} onClick={() => setFilter("")}><ClearIcon /></IconButton>: <SearchIcon />}
                </InputAdornment>
              ),
            }}}
          />
        </ListItem>
        {Object.keys(providersByInvalid).map(reason => shouldShow(reason) ? <Fragment key={reason}>
          <ListSubheader sx={{ cursor: "default" }}>{reason}</ListSubheader>
          {providersByInvalid[reason].map(p => p.label.toLowerCase().match(filter) ? <ListItem key={p.value} sx={{ ml: 1.5, cursor: "default" }}>{p.label}</ListItem> : null)}
        </Fragment> : null)}
      </List>
    </Menu>
  </>
}

export default UnavailableProviders;
